import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import "./EsameDetailPage.css";

const EsameAudiometricoPage: React.FC = () => {
  return (
    <div className="esame-detail-page">
      <div className="esame-detail-container">
        <Link to="/esami" className="esame-detail-back">
          <FontAwesomeIcon icon={faArrowLeft} />
          Torna agli esami
        </Link>

        <div className="esame-detail-content">
          <div className="esame-detail-text">
            <h1 className="esame-detail-title">
              Esame Audiometrico
            </h1>

            <div className="esame-detail-description">
              <h2>Cos'è</h2>
              <p>
                È un test dell'udito non invasivo che si utilizza per valutare la capacità 
                uditiva del paziente. Individua l'intensità acustica minima che l'orecchio 
                è in grado di percepire.
              </p>

              <h2>Come si svolge</h2>
              <p>
                Si utilizzano toni puri inviati alle orecchie del paziente a diverse intensità 
                e i risultati vengono riportati su un audiogramma. Il paziente sottoposto all'esame 
                si posiziona all'interno di una cabina insonorizzata e indossa un paio di cuffie.
              </p>

              <h2>A cosa serve</h2>
              <p>
                L'esame audiometrico permette di:
              </p>
              <ul>
                <li>Valutare la capacità uditiva complessiva del paziente</li>
                <li>Individuare eventuali deficit uditivi e determinarne l'entità</li>
                <li>Monitorare l'evoluzione di patologie dell'udito nel tempo</li>
                <li>Verificare l'efficacia di trattamenti o apparecchi acustici</li>
                <li>Diagnosticare la tipologia di ipoacusia (trasmissiva, neurosensoriale o mista)</li>
              </ul>
            </div>
          </div>

          <div className="esame-detail-image-container">
            <img
              src={require("../assets/carousel/PHOTO-2025-10-16-20-09-03 3.jpg")}
              alt="Esame Audiometrico"
              className="esame-detail-image"
            />
          </div>
        </div>

        <div className="esame-detail-cta">
          <h3>Vuoi prenotare questo esame?</h3>
          <p>
            Contattaci per maggiori informazioni o per fissare un appuntamento
          </p>
          <Link to="/#prenota" className="esame-detail-cta-btn">
            Prenota ora
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EsameAudiometricoPage;
